import React from 'react';
import { SlideUpOverlay } from './SlideUpOverlay';

/** Bottom sheet overlay — uses shared VO2 slide-up motion. */
export function MobileSheet({
  open,
  onClose,
  title,
  subtitle,
  header,
  children,
  footer,
  zIndex,
  portalContainer,
  sheetClassName,
}: {
  open: boolean;
  onClose: () => void;
  title?: string;
  subtitle?: string;
  /** Custom header slot — overrides title/subtitle block when set. */
  header?: React.ReactNode;
  children: React.ReactNode;
  footer?: React.ReactNode;
  zIndex?: number;
  portalContainer?: HTMLElement | null;
  sheetClassName?: string;
}) {
  return (
    <SlideUpOverlay
      open={open}
      onClose={onClose}
      variant="sheet"
      zIndex={zIndex}
      portalContainer={portalContainer}
      panelClassName={['mobile-sheet', sheetClassName].filter(Boolean).join(' ')}
      aria-label={title}
    >
      <div className="mobile-sheet__grab" aria-hidden />
      {header ?? ((title || subtitle) ? (
        <div className="mobile-sheet__header">
          {title && <h3 className="mobile-sheet__title">{title}</h3>}
          {subtitle && <p className="mobile-sheet__subtitle">{subtitle}</p>}
        </div>
      ) : null)}
      <div className="mobile-sheet__body">{children}</div>
      {footer && <div className="mobile-sheet__footer">{footer}</div>}
    </SlideUpOverlay>
  );
}
